export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

export const BASE_POINT = 100;

export const COMBO_DECAY_IDLE_MS = 700;
export const COMBO_DECAY_AMOUNT = 2;

export const EMA_ALPHA = 0.25;
export const EMA_INITIAL_DELTA = 1200;

export const SPEED_FACTOR_MIN = 0.8;
export const SPEED_FACTOR_MAX = 1.6;
export const SPEED_FACTOR_REFERENCE_MS = 1200;
